import { createReducer, on } from '@ngrx/store';
import { logins, loginFailure, loginSuccess, logout, enable2FaSuccess, backToPortal, currentUser, currentUserSuccess, currentUserFailure, applyLoginSuccess } from './authentication.actions';
import { sharedInitialState } from './auth.models';

export const authenticationReducer = createReducer(

    sharedInitialState,
    on(logins, (state) => ({ ...state, error: null })),
    on(loginSuccess, (state, { user }) => ({ ...state, isLoggedIn: true, user, error: null})),
    on(applyLoginSuccess, (state, { user }) => ({ ...state, user, error: null})),
    on(loginFailure, (state, { error }) => ({ ...state, error })),
    on(enable2FaSuccess, (state) => ({ ...state, 
                                        user: {
                                            ...state.user,
                                            qrcode: null,
                                            two_factor_backup_codes: null,
                                        },
                                    })),

    on(logout, (state) => ({ ...state, user: null })),
    on(backToPortal, (state) => ({ ...state, user: null })),
    
    //Fetch logged in user
    on(currentUser, (state) => ({ ...state, loading: true, error: null })),
    on(currentUserSuccess, (state, { user }) => ({ ...state, loading: false, isLoggedIn: true, user, error: null})),
    on(currentUserFailure, (state, { error }) => ({ ...state, loading: false, error })),

);